import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { OemConstants } from '../../../../app/core/routing/services/oem/constants/oem.constants';
import { OemService } from '../../../../app/core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { ModelSKU } from '../interface/oem-portal-interface.i';
import { OemStoreService } from '../store/oem.store';
import { Utils } from 'src/app/common/utils/utils';


@Component({
  selector: 'iposcen-model-sku-info',
  templateUrl: './model-sku-info.component.html',
  styleUrls: ['./model-sku-info.component.scss']
})
export class ModelSkuInfoComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  @Output() isModelSkuPresent = new EventEmitter();
  modelSkuList = [];  //Populate this variable with modelsku's info.
  hasData: boolean;
  showFrom: number;
  showTo: number;
  paginationCount: number;
  page: number;
  tableSize: number;
  isAscendingSort = false;
  sortQueue = {};
  searchQueue = {};
  filterString: string;
  searchClose: boolean;
  loadFlag: string;
  searchTag: string;
  systemID: string;
  maxSize = 5;
  displayModelName = [];
  globalSortValue: string;
  globalSortBy: string;
  searchPlaceholder: string = OemConstants.SYSTEMID_PLACEHOLDER;
  newModelSKUButton: string = "New Model SKU";
  modelSKUNAME = [];
  ellipsesCount = 12;
  updateModelSku: ModelSKU;
  noDataOnSearch: boolean;
  displayName: any[];
  displayEnglishName: any[];
  skuIdToEdit: string;
  editAlt = OemConstants.editAlt;
  searchAlt = OemConstants.searchAlt;
  closeAlt = OemConstants.closeAlt;
  editTooltip = OemConstants.EDIT_TEXT;
  allModelSkuCsvData = [];
  downloadPopupContent = OemConstants.DOWNLOAD_POPUP_CONTENT;
  private ngUnsubscribe = new Subject();
  objArray: any = [];
  sortBy: string;
  sortOrder: string;
  colSortKey: string;
  conflictingModelId: string;
  oemConst = OemConstants;
  constructor(private router: Router, private oemStore: OemStoreService, private oemservice: OemService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.colSortKey = '';
    this.hasData = true;
    this.page = 1;
    this.tableSize = 10;
    this.searchClose = false;
    this.loadFlag = "Y";
    this.globalSortBy = "updatedTime";
    this.globalSortValue = "desc";
    this.noDataOnSearch = false;
    this.getFilterSearchData();
    // For IIT2-9954 story /  UAT-882 Bug
    // this.oemservice.getAllModelSKUBySystemId(this.globalSortBy, this.globalSortValue, '')
    //   .subscribe(getAllModelSkuInfo => {
    //     this.objArray = getAllModelSkuInfo.modelSKUs as ModelSKU[];
    //     this.objArray.sort((a, b) => a?.displayName?.trim().toLowerCase().localeCompare(b?.displayName?.trim().toLowerCase()));
    // });
    // For IIT2-9954 story /  UAT-882 Bug
    // setTimeout(_ => {
    //   this.sortingTableWithAscandDesc(OemConstants.DISPLAY_NAME);
    //  }, 3000);
  }

  extractConflictingModelIds() {
    this.modelSkuList.forEach((obj) => {
      if (obj.errorMessage) {
        const pattern = /conflictingModelId=([^}]+)}/;
        const match = obj.errorMessage.match(pattern);
        if (match && match[1]) {
          obj.conflictingModelId = match[1];
        } else {
          obj.conflictingModelId = null;
        }
      } else {
        obj.conflictingModelId = null;
      }
    });
  }



  getAllModelSKUBySystemId(filterString?: string) {
    this.oemservice.getAllModelSKUBySystemId(this.globalSortBy, this.globalSortValue, filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllModelSkuInfo => {
        this.modelSkuList = getAllModelSkuInfo.modelSKUs as ModelSKU[];
        this.extractConflictingModelIds();
        if (this.modelSkuList.length) {
          this.hasData = true;
          this.showFrom = ((this.page - 1) * this.tableSize) + 1;
          this.isModelSkuPresent.emit('true')
        } else {
          this.hasData = false;
          this.showFrom = 0;
          this.showTo = 0;
          this.isModelSkuPresent.emit('false');
        }
        if (this.modelSkuList.length < 10) {
          this.showTo = this.modelSkuList.length;
        } else {
          this.showTo = this.page * this.tableSize;
        }
        // For IIT2-9954 story /  UAT-882 Bug
        // if(this.sortOrder == 'asc'){
        //   this.objArray.sort((a, b) => a?.[`${this.sortBy}`]?.trim().toLowerCase().localeCompare(b?.[`${this.sortBy}`]?.trim().toLowerCase()));
        // }else{
        //   this.objArray.sort((b, a) => a?.[`${this.sortBy}`]?.trim().toLowerCase().localeCompare(b?.[`${this.sortBy}`]?.trim().toLowerCase()));
        // }
        // this.modelSkuList = this.objArray;  

        this.modelSKUNAME = this.modelSkuList;
        this.displayEnglishName = this.modelSkuList;
        this.checkModelName();
        this.checkDisplayName();

      })


  }

  checkArray(data) {

    try {
      let temp = JSON.parse(data);
      if (typeof temp === 'number') {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  checkModelName() {
    this.displayModelName = [];
    this.modelSKUNAME.forEach(data => {
      if (this.checkArray(data.systemModels)) {
        let temp = JSON.parse(data.systemModels);
        if ((temp[0] + temp[1]).length < this.ellipsesCount) {
          if (temp.length === 2) {
            data.systemModels = temp[0] + ',' + temp[1];
          } else {
            data.systemModels = [(temp[0] + ',' + temp[1]).slice(0, this.ellipsesCount) + '...', temp, 'popup2'];
          }

        } else {

          data.systemModels = temp[0].toString().length >= this.ellipsesCount ? [temp[0].toString().slice(0, this.ellipsesCount) + '...', temp, 'popup1'] :
            [(temp[0] + ',' + temp[1]).slice(0, this.ellipsesCount) + '...', temp, 'popup1'];
        }
      } else {
        data.systemModels = data.systemModels.length < this.ellipsesCount ? data.systemModels : [data.systemModels.slice(0, this.ellipsesCount) + '...', data.systemModels, 'tooltip']
      }

      this.displayModelName.push(data);
    });
    this.modelSkuList = this.displayModelName;
  }

  checkDisplayName() {
    this.displayName = [];
    this.modelSKUNAME.forEach(data => {
      if (this.checkArray(data.displayName)) {
        let temp = JSON.parse(data.displayName);
        if (data.displayName == undefined) {
          data.displayName = 'Error';

        } else {
          data.displayName = temp.en_US;
        }
      }
      this.displayName.push(data);
    })
    this.modelSkuList = this.displayName;
    //Fix for UAT-882
    if (this.colSortKey === 'displayName') {
      let sortOrderAsc = this.isAscendingSort;
      this.modelSkuList.sort(function (a, b) {
        if (sortOrderAsc) {
          return a.displayName.localeCompare(b.displayName, undefined, { numeric: true, sensitivity: 'base' });
        } else {
          return b.displayName.localeCompare(a.displayName, undefined, { numeric: true, sensitivity: 'base' });
        }
      })
    }
  }

  checkIfList(data) {
    return typeof data !== 'object';
  }

  // Call the search api here
  searchData(systemID) {
    this.searchClose = true;
    if (this.loadFlag === "Y" && !this.searchTag) {
      this.searchTag = 'systemidsearch';
      this.loadFlag = 'N';
    }
    if (systemID && this.searchTag) {
      this.searchQueue[this.searchTag] = systemID;
      this.getSearchData(systemID);
    } else {
      this.getAllModelSKUBySystemId();
      this.page = 1;
    }

  }

  getSearchData(systemID) {
    this.oemservice.searchWithSystemID(systemID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
        this.modelSkuList = result.modelSKUs as ModelSKU[];
        this.modelSKUNAME = this.modelSkuList;
        if (this.modelSkuList.length) {
          this.hasData = true;
          this.noDataOnSearch = false;
          this.showFrom = ((this.page - 1) * this.tableSize) + 1;
          this.isModelSkuPresent.emit('true')
        } else {
          this.noDataOnSearch = true;
          this.showFrom = 0;
          this.showTo = 0;
          this.isModelSkuPresent.emit('false');
        }
        if (this.modelSkuList.length < 10) {
          this.showTo = this.modelSkuList.length;
        } else {
          this.showTo = this.page * this.tableSize;
        }
        this.checkModelName();
        this.checkDisplayName();
      })
  }

  searchDataOnEnter(systemID) {
    this.animateThis.nativeElement.blur();
    this.searchData(systemID);

  }

  clearSearch() {
    this.searchClose = false;
    this.noDataOnSearch = false;
    this.systemID = '';
    this.searchQueue = {};
    this.getFilterSearchData();
    this.showFrom = this.page = 1;
    this.showTo = Math.min(this.page * this.tableSize, this.modelSkuList.length);
  }

  sort(sortKey: string) {
    this.colSortKey = sortKey;
    switch (sortKey) {
      case ('systemID'):
        this.sortingTableWithAscandDesc('systemID');
        break;
      case ('detectionStatus'):
        this.sortingTableWithAscandDesc('detectionStatus');
        break;
      case ('displayName'):
        this.sortingTableWithAscandDesc('displayName');
        break;
      case ('createdTime'):
        this.sortingTableWithAscandDesc('createdTime');
        break;
      case ('updatedTime'):
        this.sortingTableWithAscandDesc('updatedTime');
        break;
      case ('editedByName'):
        this.sortingTableWithAscandDesc('editedByName');
        break;
      default: {
      }
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    let sortOrder = "";
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = this.isAscendingSort ? "asc" : "desc";

    this.sortQueue["sortby"] = tempval;
    this.sortQueue["sorttype"] = sortOrder;
    // For IIT2-9954 story
    // this.sortBy=tempval;
    // this.sortOrder=sortOrder;      
    this.getFilterSearchData();
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.sortQueue) {

      for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }

      this.getAllModelSKUBySystemId(this.filterString);
    } else {
      this.getAllModelSKUBySystemId();
    }
  }


  createNewModelSKU() {
    this.oemStore.oemStoreData = undefined;
    this.router.navigate([RouterConstants.CREATE_MODEL_SKU_INFO]);
  }

  checkCase(data) {
    if (data === 'approved') {
      return data.replace(data, 'Approved');
    } else if (data === 'submitted') {
      return data.replace(data, 'Submitted');
    } else if (data === 'returned') {
      return data.replace(data, 'Returned');
    } else if (data === 'delete requested') {
      return data.replace(data, 'Delete Requested');
    }
  }

  onTableDataChange(event) {
    this.page = event;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize, this.modelSkuList.length);
    this.extractConflictingModelIds();
  }
  editSKU(id: string) {
    this.oemStore.oemStoreData = undefined;
    this.router.navigate([RouterConstants.EDIT_SKU, id]);
  }

  // For IIT3-4 story
  downloadModelSkuCsvFile() {
    if (navigator.onLine) {
      const modelskubody = {
        csvHeaders: []
      };
      modelskubody.csvHeaders.push(OemConstants.SYSTEM_ID);
      modelskubody.csvHeaders.push(OemConstants.SYSTEM_MODEL);
      modelskubody.csvHeaders.push(OemConstants.DOWNLOAD_MODEL_STATUS);
      modelskubody.csvHeaders.push(OemConstants.ENGLISH_DISPLAY_NAME);
      modelskubody.csvHeaders.push(OemConstants.OPERATING_SYSTEM);
      modelskubody.csvHeaders.push(OemConstants.LAST_UPDATED_CSV);
      modelskubody.csvHeaders.push(OemConstants.LAST_UPDATED_BY);

      this.oemservice.postModelSkuCsv(modelskubody)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(getAllModelSkuData => {
          this.downloadSkuCsv(getAllModelSkuData);
        });
    }
  }

  downloadSkuCsv(csvResponse) {
    this.allModelSkuCsvData = csvResponse;
    let filename = sessionStorage.getItem('partnerName');
    let userfilename = filename + '_' + OemConstants.MODELS_SKUS + '_' + Utils.getdownloadLink();
    userfilename = userfilename.replace(",", "_").replace(";", "_");
    Utils.downloadCsvFile(this.allModelSkuCsvData, userfilename);
  }
}
